import { RootState } from '@store/index'
import { useSelector } from 'react-redux'

const selector = (state: RootState) => state.session

export function useSession() {
  return useSelector(selector)
}